export let experienceInfoReqDTO = {
    isSubmittable:"",
    typeEmploymentLookupId: "",
    isBpscSelection: "",
    postNameLookupId: "",
    postNameOther: "",
    officeName: "",
    isOfficeGovOwned: "",
    designation: "",
    designationId: "",
    jobNatureLookupId: "",
    isGazettedPost: "",
    typeGroupLookupId: "",
    apointmentNatureLookupId: "",
    fullTimeLookupId:"",
    appointmentLetterNo: "",
    appointmentLetterDate: "",
    payScale: "",
    gradePay: "",
    basicPay: "",
    monthlyGrossSalary: "",
    employmentFrom: "",
    employmentTo: "",
    expYears: "",
    expMonths: "",
    expDays: "",    
    isDeleted:"",
    remarks: "",
    isExperience:"",
    employeeTypeLookupId:"",
    institutionLookupId:""
};